import { Injectable } from '@angular/core';

// Rx JS imports
import { Observable } from 'rxjs';
import { map, first } from 'rxjs/operators';
import { combineLatest } from 'rxjs';

// Models
import { MapStyle } from '../models/map-style';
import { ListenEvent } from './database';
import { DatabaseService } from './database.service';

@Injectable({ providedIn: 'root' })
export class StyleService {

    constructor(private af: DatabaseService) {
    }

    public init() {
    }

    public generateKey(): string {
        return this.af.database.ref().push().key;
    }

    public saveMapStyle(mapStyle: MapStyle): Promise<any> {
        // Get new id for mote
        if(!mapStyle.key) {
            // Generate new key
            mapStyle.key = this.generateKey()
            mapStyle.createdOn = this.af.serverTime();
        }
        // Create database reference and update moteContent
        return this.af.database.ref("/mapStyles/" + mapStyle.key).update(mapStyle.toJson());
    }

    public async deleteMapStyle(mapStyle: MapStyle): Promise<boolean> {
        if(!mapStyle.key) return false;
        return this.af.database.ref("/mapStyles/" + mapStyle.key).remove().then(() => true).catch(() => false);
    }

    public watchMapStyles(projectKey: string): Observable<MapStyle[]> {
        const CHANGE_EVENTS: Array<ListenEvent> = [ListenEvent.added, ListenEvent.removed, ListenEvent.changed, ListenEvent.moved];
        // Get project styles from DB
        let projectStyles = this.af.list("/mapStyles/", query => query.orderByChild('project').equalTo(projectKey)).snapshotChanges(CHANGE_EVENTS).pipe(map((results) => {
            // Create array of Project objects from firebase object array
            return results.map((json) => {
                return new MapStyle(json.key, json.payload.val());
            });
        }));

        // Only return styles one time for default project
        if(projectKey == "default") return projectStyles;

        // Get default Motes styles from DB
        let defaultStyles = this.af.list("/mapStyles/", query => query.orderByChild('project').equalTo("default")).snapshotChanges(CHANGE_EVENTS).pipe(map((results) => {
            // Create array of Project objects from firebase object array
            return results.map((json) => {
                return new MapStyle(json.key, json.payload.val());
            });
        }));

        return combineLatest(defaultStyles, projectStyles).pipe(map(([defStyles, proStyles]) => {
            return [...defStyles, ...proStyles];
        }));
    }

    public watchMapStyle(styleKey: string): Observable<MapStyle> {
        // Get style from DB and map to MapStyle object
        return this.af.object("/mapStyles/" + styleKey).snapshotChanges().pipe(map((json) => {
            return new MapStyle(styleKey, json.payload.val());
        }));
    }

    public getMapStyle(styleKey: string) {
        return this.watchMapStyle(styleKey).pipe(first()).toPromise();
    }
}

